import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateVisitPackageMutation as UpdateVisitPackageMutationType,
  UpdateVisitPackageMutationVariables,
} from "./__generated__/UpdateVisitPackageMutation";

const UpdateVisitPackageMutation = loader("./UpdateVisitPackageMutation.gql");

type UpdateVisitPackageMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateVisitPackageMutationType) => void;
}) => ReactElement;

export const UpdateVisitPackageMutationProvider: UpdateVisitPackageMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateVisitPackageMutationType, UpdateVisitPackageMutationVariables>(
    UpdateVisitPackageMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
